<template>
  <div class="card shadow-bg">
    <div class="border-0 card-header">
      <h3 class="mb-0">Affiliates</h3>
    </div>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      empty-text="No Affiliates"
      :data="affiliates"
    >
      <el-table-column label="Affiliate" min-width="120px" prop="name" sortable>
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="media-body">
              <router-link
                :to="{
                  name: 'Affiliate Details',
                  params: { id: row.id }
                }"
              >
                <span class="font-weight-600 mb-0 text-sm text-break">{{
                  row.name
                }}</span>
              </router-link>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="Referrals"
        min-width="190px"
        prop="referrals"
        sortable
      >
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="">
              <span class="mb-0 text-sm">{{ row.referrals }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Paid Referrals"
        min-width="190px"
        prop="paidReferrals"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <div class="=">
              <span class="mb-0 text-sm">{{ row.paidReferrals }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="$ Earned"
        min-width="190px"
        prop="amountEarned"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <div class="">
              <span class="mb-0 font-weight-700 text-sm">{{
                `$${row.amountEarned.toFixed(2)}`
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="$ Paid"
        min-width="190px"
        prop="amountPaid"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <div class="">
              <span class="mb-0 font-weight-700 text-sm">{{
                `$${row.amountPaid.toFixed(2)}`
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="$ Due"
        min-width="190px"
        prop="amountDue"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <div class="">
              <span class="mb-0 font-weight-700 text-sm">{{
                `$${row.amountDue.toFixed(2)}`
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Statistics" min-width="120px">
        <template v-slot="{ row }">
          <div class="align-items-center">
            <div class="">
              <router-link
                :to="{ path: `/affiliates/affiliate/${row.id}/statistics` }"
                class="btn btn-light shadow btn-icon-only"
              >
                <i class="fas fa-chart-bar text-white"></i>
              </router-link>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Table,
  TableColumn
} from 'element-ui'

export default {
  name: 'AffiliateTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    affiliates: Array
  }
}
</script>

<style scoped></style>
